export const API_URL            = 'https://api.earthdecks.org/v1/';
export const APP_URL            = 'https://api.earthdecks.org/';
export const DEFAULT_USER_IMAGE = "/assets/images/user-profile.png";
export const DEFAULT_PROJECT_IMAGE = "/assets/images/user-profile.png";
export const NO_IMAGE           = "/assets/images/no-image.jpg";
export const OPEN_URL           = "open-url";
export const PLAY_VIDEO         = "play-video";
export const GOTO_COURSE        = "goto-course";
export const GOTO_THEME         = "goto-theme";
export const GOTO_UNIT          = "goto-unit";
export const GOTO_PACKAGE       = "goto-package";
export const GOTO_PROFILE       = "goto-profile";
export const TAG_COUNT          = 70;
export const TAG_TITLE_COUNT    = 24;
export const FILE_SIZE          = 2097152; //2 MB



// WEBPACK FOOTER //
// ./config/config.js